import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { addGroupSuccess, addGroupFailure } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

function* addGroup({ payload }) {
  const url = `${API_BASE_URL}/application-groups`;

  const response = yield request({
    method: 'post',
    data: payload,
    url,
  });
  if (response.success) {
    yield put(
      addGroupSuccess({
        value: response.raw.id,
        label: response.raw.name,
      })
    );
    Notify('Group Added Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(
      addGroupFailure('An error occured. Please reload the page to try again.')
    );
    const errorMesssage = response.statusCode === 409 ? 'Group already exists' : response.message;
    networkErrorHandler(response?.statusCode, errorMesssage);
  }
}

export function* onAddGroup() {
  yield takeLatest(GroupActionTypes.ADD_GROUP, addGroup);
}
